import React from "react";

var InlineErrorMessageSVG = function InlineErrorMessageSVG() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "action/error",
    clipPath: "url(#clip0_3243_4865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M11.314 0H4.686L0 4.686V11.314L4.686 16H11.314L16 11.314V4.686L11.314 0ZM8 12C7.86659 12.008 7.73299 11.9876 7.60803 11.9402C7.48307 11.8928 7.36959 11.8194 7.27508 11.7249C7.18057 11.6304 7.10719 11.5169 7.05977 11.392C7.01235 11.267 6.99198 11.1334 7 11C6.99198 10.8666 7.01235 10.733 7.05977 10.608C7.10719 10.4831 7.18057 10.3696 7.27508 10.2751C7.36959 10.1806 7.48307 10.1072 7.60803 10.0598C7.73299 10.0124 7.86659 9.99198 8 10C8.13341 9.99198 8.26701 10.0124 8.39197 10.0598C8.51693 10.1072 8.63041 10.1806 8.72492 10.2751C8.81943 10.3696 8.89281 10.4831 8.94023 10.608C8.98765 10.733 9.00802 10.8666 9 11C9.00802 11.1334 8.98765 11.267 8.94023 11.392C8.89281 11.5169 8.81943 11.6304 8.72492 11.7249C8.63041 11.8194 8.51693 11.8928 8.39197 11.9402C8.26701 11.9876 8.13341 12.008 8 12ZM9 9H7V4H9V9Z",
    fill: "#DC0A0A"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3243_4865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
};

export default InlineErrorMessageSVG;